import React from "react";

import styled from 'styled-components';

const DashboardCardWrapper = styled.div`
    background-color: #fff;
    min-width: 233px;
    border-radius: 2px;
    border-top: ${props => '4px solid ' + props.borderColor};
`;

const DashboardCardTitle = styled.div`
     border-bottom: 1px solid #CCCCCC;
     display: flex;
     align-items: center;
     justify-content: space-between;
     padding:16px;
`;

const DashboardCardTitleText = styled.h3`
     font-family: Helvetica, sans-serif;
     font-size: 14px;
     line-height: 15px;
`;

const DashboardAllTimeSwitch = styled.label`
     font-size: 10px;
     background-color: #999a9a;
     color: #fff;
     border-radius: 3px;
     padding:2px 6px;
`;

const DashboardCardCount = styled.p`
     font-size: 30px;
     font-weight: bold;
     margin:  0 0 11px 0;
`;
const DashboardCardDescription = styled.div`
     padding:16px;
`;
const DashboardCardStatistics = styled.p`
     color: #102027;
     font-size: 11px;
     margin: 0;
     line-height: 22px;
     font-family: Times, "Times New Roman", Times32;
`;


const DashboardCard = (props) =>
    <DashboardCardWrapper borderColor={props.color}>
        <DashboardCardTitle>
            <DashboardCardTitleText>{props.title}</DashboardCardTitleText>
            <DashboardAllTimeSwitch>All time</DashboardAllTimeSwitch>
        </DashboardCardTitle>
        <DashboardCardDescription>
            <DashboardCardCount>{props.count}</DashboardCardCount>
            {/*<DashboardCardStatistics>*/}
                {/*<b>2</b> project has been created by you*/}
            {/*</DashboardCardStatistics>*/}
            {/*<DashboardCardStatistics>*/}
                {/*<b>5</b> created by your team members*/}
            {/*</DashboardCardStatistics>*/}
        </DashboardCardDescription>
    </DashboardCardWrapper>

export default DashboardCard
